module.exports = __webpack_public_path__ + "static/img/businessLicense.992f832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/businessLicense.png
// module id = TK+b
// module chunks = 18